module.exports = __webpack_public_path__ + "img/stock0.59d0b35a.png";